import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import api from '../api/client';

function firstError(data) {
  if (!data) return '';
  if (typeof data.detail === 'string') return data.detail;
  for (const key of ['password', 'token', 'uid', 'non_field_errors']) {
    const val = data[key];
    if (Array.isArray(val) && val[0]) return val[0];
    if (typeof val === 'string') return val;
  }
  return 'Не удалось сменить пароль. Запросите новую ссылку.';
}

export default function ResetPasswordPage() {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== password2) {
      setError('Пароли не совпадают.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/password-reset/confirm/', {
        uid,
        token,
        password,
      });
      navigate('/login', { state: { passwordResetOk: true } });
    } catch (err) {
      setError(firstError(err.response?.data));
    } finally {
      setLoading(false);
    }
  }

  if (!uid || !token) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h2>Ссылка недействительна</h2>
          <p className="auth-subtitle">Запросите новую ссылку для сброса пароля.</p>
          <p className="auth-link">
            <Link to="/forgot-password">Восстановить пароль</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Новый пароль</h2>
        <p className="auth-subtitle">Придумайте новый пароль для входа</p>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="new-password">Новый пароль</label>
            <input
              id="new-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Новый пароль"
              required
              autoFocus
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label htmlFor="new-password2">Повторите пароль</label>
            <input
              id="new-password2"
              type="password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              placeholder="Ещё раз"
              required
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Сохранение...' : 'Сохранить пароль'}
          </button>
        </form>
        <p className="auth-link">
          <Link to="/login">Вернуться ко входу</Link>
        </p>
      </div>
    </div>
  );
}
